import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import selectionsFiltersList from "../../../assets/img/selectionsFiltersList.svg";

export function NoData() {
  return (
    <Box
      id="no-data-available-message"
      data-testid="workspace-no-data-message"
      display="flex"
      height="100%"
      alignItems="center"
      justifyContent="center"
      bgcolor="#edeff1"
    >
      <Stack spacing={1}>
        <img
          src={selectionsFiltersList}
          alt="no-data-available"
          width={100}
          height={100}
          style={{
            alignSelf: "center",
          }}
        />
        <Typography variant="h3" alignSelf="center">
          No data available for the selected filters.
        </Typography>
        <Typography variant="body1" alignSelf="center">
          Try adjusting your filters.
        </Typography>
      </Stack>
    </Box>
  );
}
